var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('span',{staticClass:"user-level",class:['user-level--' + _vm.className]},[_vm._v(_vm._s(_vm.name))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }